import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row } from 'react-bootstrap';
import { FaToolbox } from 'react-icons/fa';
import { BsBoxFill } from 'react-icons/bs';

const InfoItem = ({ title, label, icon }) => {
  return (
    <div
      style={{
        borderLeft: '4px solid blue', // Adjust the width as needed
        paddingLeft: '1rem',
        marginBottom: '1rem' // Add spacing between items
      }}
    >
      <p style={{ marginBottom: '5px' }}>{title}</p>
      <div className="d-flex align-items-center gap-2">
        {icon && icon} <h5 className="fw-semibold">{label}</h5>
      </div>
    </div>
  );
};

const InformationsProduit = ({ produit }) => {
  return (
    <Row>
      <Card>
        <Card.Body>
          <h4 className="fw-semibold">Informations sur le produit</h4>
          {/* <div
            style={{
              borderLeft: '4px solid blue', // Adjust the width as needed
              paddingLeft: '1rem'
            }}
          >
            <p style={{ marginBottom: '0px' }}>Type</p>
            <h5 className="fw-bold">{produit.typeProduit}</h5>
          </div> */}
          <InfoItem
            title="Type"
            label={produit.typeProduit}
            icon={
              produit.typeProduit === 'Matériel' ? <BsBoxFill /> : <FaToolbox />
            }
          />
          <InfoItem title="Marque" label={produit.marque || '--'} />
          <InfoItem title="Référence" label={produit.reference || '--'} />
          <InfoItem
            title="Référence fournisseur"
            label={produit.refFournisseur || '--'}
          />
          <InfoItem title="Code à barres" label={produit.codebarres || '--'} />
          <InfoItem title="Description" label={produit.description || '--'} />
        </Card.Body>
      </Card>
    </Row>
  );
};
InformationsProduit.propTypes = {
  produit: PropTypes.object.isRequired
};

InfoItem.propTypes = {
  title: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.element
};

export default InformationsProduit;
